import {
  validateBoolean,
  createObjectValidator,
  validateString
} from "../../../packages/validator/validator.js";

/**
 * Configuration object for Organizer frontend.
 */
export type FrontendConfiguration = {
  isCloudOnly: boolean;
  /**
   * Code version. Can be used for cache busting.
   */
  version: string;
};

export const validateFrontendConfiguration = createObjectValidator<FrontendConfiguration>(
  "FrontendConfiguration",
  {
    isCloudOnly: validateBoolean,
    version: validateString
  }
);
